export default __webpack_public_path__ + "static/media/illustration-phone-mockup.a970dc85.svg";